export const getRandomArrayItem = <T>(arr: Array<T>): T =>
  arr[Math.floor(Math.random() * arr.length)]
